import { collection, getDocs, query, orderBy, doc, getDoc } from 'firebase/firestore';
import { db } from '../../../../firebase/config';
import { fetchCompanyBankId } from '../../../companies/service/companiesService';

export type BAMSRequest = {
    id: string;
    requestId?: string;
    branchCode?: string;
    branchName?: string;
    company?: string;
    companyId?: string;
    requesterName?: string;
    requesterContact?: string;
    status?: string;
    createdAt?: any;
    updatedAt?: any;
    requestType?: string;
    [key: string]: any;
};

/**
 * Fetch company ID for the current user (PSO or Bank user)
 */
export async function fetchCompanyId(uid: string, isBankUser: boolean = false): Promise<string | null> {
    try {
        return await fetchCompanyBankId(uid, isBankUser);
    } catch (error) {
        console.error('Error fetching company ID:', error);
        return null;
    }
}

/**
 * Fetch all BAMS requests for a company
 */
export async function fetchBAMSRequests(companyId: string): Promise<BAMSRequest[]> {
    if (!companyId) {
        return [];
    }

    try {
        const requestsSnap = await getDocs(
            query(
                collection(db, 'banks', companyId, 'hardware_requests'),
                orderBy('createdAt', 'desc')
            )
        );

        const requestsList = requestsSnap.docs
            .map(doc => ({
                id: doc.id,
                ...doc.data()
            }))
            .filter((request: any) => request.requestType === 'BAMS') as BAMSRequest[];

        return requestsList;
    } catch (error) {
        console.error('Error fetching BAMS requests:', error);
        throw error;
    }
}

